import { useSetRecoilState } from 'recoil';
import { useNavigate } from 'react-router-dom';

import { connectToGameRoom } from '@/realtime/connect-game-room';

import { openModal, closeModal } from '@/use/useModal';
import { isMenuOpenState } from '@/use/useMenuState';

import useExitGame from './useExitGame';
import useStartGame from './useStartGame';

/**
 * When player joins game from the friend invite
 */

const useJoinGame = () => {
  const navigate = useNavigate();
  const setIsMenuOpen = useSetRecoilState(isMenuOpenState);
  const { clearGame } = useExitGame();
  const startGame = useStartGame();

  const joinGame = async (gameId: string) => {
    /**
     * Exit any previous game if present
     */
    clearGame();

    openModal('connect');

    try {
      const joined = await connectToGameRoom(gameId);
      const type =
        joined.type === 'random' || joined.type === 'invite'
          ? joined.type
          : 'invite';
      startGame(gameId, type);
      setIsMenuOpen(false);
      closeModal();
    } catch (err) {
      clearGame();

      openModal('not-found', {
        onRequestClose: () => {
          closeModal();
          navigate('/');
        },
      });

      throw err;
    }
  };

  return joinGame;
};

export default useJoinGame;
